import React, { memo } from 'react'
import UserAuthScreen from '~/packages/general/user/auth/userAuth.screen'
import Loader from '~/prix/react/components/loader'
import useAPI from '~/prix/react/hooks/api'

export interface Screen {
  mustBeAuthenticated?: boolean
  children: React.ReactNode
}

function Screen({ children, mustBeAuthenticated = true }: Screen) {
  const api = useAPI()
  const isAllowed = mustBeAuthenticated ? Boolean(api.context.user) : true

  if (isAllowed && !api.isLoading) {
    return children
  }
  if (api.isLoading) {
    return <Loader />
  }
  return <UserAuthScreen />
}

export default memo(Screen)
